import { render, staticRenderFns } from "./ZurnalasSiunciami.vue?vue&type=template&id=612cf1f6&scoped=true&"
import script from "./ZurnalasSiunciami.vue?vue&type=script&lang=js&"
export * from "./ZurnalasSiunciami.vue?vue&type=script&lang=js&"
import style0 from "./ZurnalasSiunciami.vue?vue&type=style&index=0&id=612cf1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cf1f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VFooter,VSpacer})
